import React, {useEffect} from "react";
import {ElementoRMLRecord} from "@commons/mapping/ElementoRMLRecord";
import {useForm} from "react-hook-form";
import * as Validation from "@utilities/validationRules";
import FormButtons from "../../../components/FormButtons";
import CheckboxEx from "../../../components/wrapperComponents/CheckboxEx";
import RadioInput from "../../../components/RadioInput";
import InputEx from "../../../components/wrapperComponents/InputEx";

interface ElementoRMLEditorProps {
    resource: ElementoRMLRecord;
    onSubmit: (formData: ElementoRMLRecord) => void,
    onCancel: () => void;
}

const ElementoRMLEditor: React.FC<ElementoRMLEditorProps> = ({resource, onSubmit, onCancel}) => {
    const defaultValues: ElementoRMLRecord = ElementoRMLRecord.factory();
    const currentValues: ElementoRMLRecord = {
        ...defaultValues,
        ...resource,
    };
    // https://stackoverflow.com/questions/62242657/how-to-change-react-hook-form-defaultvalue-with-useeffect
    const {register, getValues, setValue, control, handleSubmit, reset, formState: {errors}} = useForm<ElementoRMLRecord>(
        /*
            {
            defaultValues: useMemo(() => {
                return currentValues;
            }, [currentValues])
        }
        */
    );

    useEffect(() => reset(currentValues), [resource]);

    function onHandleSubmit(newValues: ElementoRMLRecord) {
        //const elementoDiscrezionale = string2Bool(newValues.elementoDiscrezionale);
        //onSubmit({...newValues, elementoDiscrezionale})
        onSubmit(newValues);
    }

    return <>

        <form onSubmit={handleSubmit(onHandleSubmit)}>
            <div className="space-y-8 divide-y divide-gray-200">
                <div>
                    <p className="text-lg font-medium leading-6">Elemento retributivo</p>
                    <p className="mt-1 text-sm text-gray-500">Gli elementi retributivi che caratterizzano la retribuzione del lavoratore sono contradistinti da un codice
                        alfanumerico
                        generico e da una descrizione.</p>
                    <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">

                        <div className="sm:col-span-2">
                            <InputEx
                                type="text"
                                name="codElemento"
                                label="Codice elemento"
                                register={register}
                                registerOptions={Validation.required}
                                errors={errors}
                            />
                        </div>

                        <div className="sm:col-span-2">
                            <InputEx
                                type="text"
                                name="descrizione"
                                label="Descrizione"
                                register={register}
                                registerOptions={Validation.required}
                                errors={errors}
                            />
                        </div>

                        <div className="sm:col-span-2">
                            <InputEx
                                type="text"
                                name="sortOrder"
                                label="Peso di ordinamento"
                                register={register}
                                registerOptions={Validation.required}
                                errors={errors}
                            />
                        </div>

                        <div className="sm:col-span-6">
                            <InputEx
                                type="text"
                                name="note"
                                label="Note"
                                placeholder="Specifica delle informazioni aggiuntive, eventuali particolarità che contraddistinguono l'elemento..."
                                register={register}
                            />
                        </div>

                    </div>
                </div>

                <div className="pt-4">
                    <div>
                        <h3 className="text-lg font-medium leading-6">Altre particolarit&agrave;</h3>
                        <p className="mt-1 text-sm text-gray-500">
                            Ogni elemento pu&ograve; essere considerato contrattuale (dettato dal CCNL applicato) o <span className="italic">ad personam</span> (determinato dalla
                            mansione,
                            dalle policies aziendali e/o dagli accordi
                            intercorsi tra l'azienda e ciascun lavoratore).
                        </p>
                        <div className="flexRowWrapFull">
                            <div className="sm2-6P">
                                <label htmlFor="tipo" className="mb-1 block font-medium text-sm">Tipologia</label>
                                <RadioInput
                                    label="Contrattuale nazionale"
                                    name="tipo"
                                    id="ccnl_nazionale"
                                    register={register}
                                    registerOptions={Validation.required}
                                    value="NAZIONALE"
                                />
                                <RadioInput
                                    label="Contrattuale territoriale"
                                    name="tipo"
                                    id="ccnl_territoriale"
                                    register={register}
                                    registerOptions={Validation.required}
                                    value="TERRITORIALE"
                                />
                                <RadioInput
                                    label="Ad-personam"
                                    name="tipo"
                                    id="adPersonal"
                                    register={register}
                                    registerOptions={Validation.required}
                                    value="AD_PERSONAM"
                                />
                                {errors && errors.tipo && <p className="text-rose-700">Specificare una tipologia!</p>}
                            </div>
                            <div className="sm2-6P">
                                <label className="mb-1 block font-medium text-sm">
                                    Per gli elementi <span className="italic">ad personam</span> possiamo quindi indicare se discrezionali o meno.
                                </label>
                                <CheckboxEx name="elementoDiscrezionale"
                                            control={control}
                                            label="Elemento discrezionale"
                                />

                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <FormButtons onCancel={onCancel} resource={resource}/>
        </form>

    </>;
}
export default ElementoRMLEditor;
